import {
  ActivitiesIcon,
  BarIcon,
  ChildcareIcon,
  CoffeeIcon,
  FitnessIcon,
  GroceryIcon,
  HealthIcon,
  PetIcon,
  ShopIcon,
} from "./icons";

export const categories = [
  "Childcare",
  "Health",
  "Fitness",
  "Grocery",
  "Pets",
  "Activities",
  "Shops",
  "Coffee",
  "Bars",
];

export const getIconForCategory = (categoryName) => {
  const matches = {
    Childcare: ChildcareIcon,
    Health: HealthIcon,
    Fitness: FitnessIcon,
    Grocery: GroceryIcon,
    Pets: PetIcon,
    Activities: ActivitiesIcon,
    Shops: ShopIcon,
    Coffee: CoffeeIcon,
    Bars: BarIcon,
  };
  return matches[categoryName];
};

const edmunds = {
  address: "1081 Morrison Dr",
  coordinates: [32.8099167, -79.9473472],
  image_url: "https://lh3.googleusercontent.com/p/AF1QipOQWtR_UnZs__Lub6PA6TuOlFXrZeZJhGStQI0E=s1600-w900",
  name: "Edmund's Oast",
  rating: 4.7,
  reviews: [
    "The staff is doing an excellent job, if not the best we’ve seen in SC, keeping staff and guest safe ",
    "First ever visit for lunch today and all I can say is just stop!! Stop with the only outdoor dining,",
    "Went with friends. Beautiful outdoor seating area with heaters. Inside dining opens at 5. Outstandin",
  ],
};

const cafe = {
  address: "62 Queen St",
  coordinates: [32.7783138, -79.93052879999999],
  image_url: "https://lh3.googleusercontent.com/p/AF1QipPS4WvfgabaXiA_ReD6af3bV8_i4Baix7D_E5F2=s1600-w900",
  name: "Harken Cafe",
  rating: 4.5,
  reviews: [
    "Harken is just marvelous.  I've been over 100 times and have always had the best service from hard w",
    "Wonderful spot ... cozy outdoor seating ... and sooooo many tasty options ranging from an array of b",
    "A fabulously Charlestonian find on Queen Street. Quaint with tasty pastries, coffee offerings and  d",
  ],
};

const school = {
  address: "15 Archdale St",
  coordinates: [32.7782623, -79.93479239999999],
  image_url: "https://fileserver.scythargon.ru/school.png",
  name: "Charleston Day School",
  rating: 5,
  reviews: [
    "This is by far the best private school in Charleston if not the state of South Carolina.  Our son ha",
    "Excellent small school in downtown Charleston where all teachers know your child and emphasize its m",
    "Awesome school with exceptional focus on character development and academics!",
  ],
};

const hospital = {
  address: "Roper Hospital",
  coordinates: [32.782578, -79.949305],
  image_url: "https://lh3.googleusercontent.com/p/AF1QipO-goI4kkpwhny8F3vSP_sUP_VAff5smcxxM5Y5=s1600-w900",
  name: "Roper Hospital",
  rating: 3.6,
  reviews: [
    "While I would love to give this hospital a good review, this is tough. I have had 2 bad experiences.",
    "Easy to find on Google Maps. Explored early on a Sunday morning before the Charleston tourist come o",
    "THEY ARE AWESOME! My 87 year-old father was transferred here during the pandemic and not allowed to ",
  ],
};

const fitness = {
  address: "163 Rutledge Ave",
  coordinates: [32.785993, -79.94570999999999],
  image_url: "https://lh3.googleusercontent.com/p/AF1QipPXU0RiutRuX0pNcj0pkGaLJfyW9pLyuba8IFXw=s1600-w900",
  name: "Longevity Fitness",
  rating: 5,
  reviews: [
    "The nicest gym I’ve ever stepped foot in! High end, so clean, and so much variety! Everything from c",
    "Hands down the best and cleanest studio and gym for your health and wellness...awesome staff that is",
    "Just finished a yoga class here on a bachelorette trip and it was fantastic. Michelle was super frie",
  ],
};

const grocery = {
  address: "290 E Bay St East Bay",
  coordinates: [32.7844814, -79.9281707],
  image_url: "https://lh3.googleusercontent.com/p/AF1QipOIkbFvSVLj-kdxhZcU-BW1Nva7DhtjsAT1jeFD=s1600-w900",
  name: "Harris Teeter",
  rating: 4.5,
  reviews: [
    "Over the past few months their floral department has been THRIVING! It is truly a floral oasis. Thei",
    "I miss dropping in here for lunch. It was always tough deciding which sandwich to get. Usually I wou",
    "Great grocery near the battery in Charleston.",
  ],
};

const dogs = {
  address: "164 Market St",
  coordinates: [32.7807514, -79.934364],
  image_url: "https://lh3.googleusercontent.com/p/AF1QipN6qZzxj95eTIv5yEoT13qlT5Bnn9TtB46_qOuD=s1600-w900",
  name: "Dogstar Dog Running & Pet Care",
  rating: 5,
  reviews: [
    "Dogstar has been fantastic and my pup loves them. Brett and his team are incredibly responsive to qu",
    "Dogstar is fantastic and they have been there for me reliably every week and every time I have neede",
    "We did what every self-respecting couple in this pandemic did and got ourselves pandemic puppies.  K",
  ],
};

const alley = {
  address: "131 Columbus St",
  coordinates: [32.7940687, -79.94086589999999],
  image_url: "https://lh3.googleusercontent.com/p/AF1QipPexLuT4bgAx5epflZzRJsmnW0sLyz72h6aHe6m=s1600-w900",
  name: "The Alley",
  rating: 4.4,
  reviews: [
    "Excellent Charleston entertainment complex with bowling, retro Arcade games, drinks, food, and fun f",
    "Seems like a really cool places to hang out with a few bowling lanes and several retro arcade games!",
    "A great time despite the current precautions.  The simple scoring system makes it very enjoyable.",
  ],
};

const hampden = {
  address: "314 King St",
  coordinates: [32.7837949, -79.934838],
  image_url: "https://lh3.googleusercontent.com/p/AF1QipMEUMRldW39SnqFs_mC1SfMNeueBeK5Ih8CIbGN=s1600-w900",
  name: "Hampden",
  rating: 4.7,
  reviews: [
    "The BEST customer service EVER! Hanna and Katherine are both phenomenal so helpful, so responsive an",
    "I purchased a cute R13 dress in the website, unfortunately then I found NORSTROM.com has went down t",
    "My shopping experience with Hampden has been stellar! Special shoutout to Katherine, Savanna and McK",
  ],
};

const moose = {
  address: "1137 Morrison Dr",
  coordinates: [32.8113921, -79.9493195],
  image_url: "https://lh3.googleusercontent.com/p/AF1QipPSfTNu5npSpCcJxScuDu5vrU_bYiq9GIsZoKRk=s1600-w900",
  name: "The Tattooed Moose",
  rating: 4.6,
  reviews: [
    "This was extremely good. Very good craft beer! Smaller place, but dining outside was great. The food",
    "Amazing dining experience. The famous duck sandwich and the Gyro wrap were delicious.\n\nThen there we",
    "Wow !!!  I've been wanting to try out this place since I had seen it on Diners, Drive-Ins and Dives ",
  ],
};

const autobahn = {
  address: "6601 Executive Park Ct N",
  coordinates: [30.25512780000001, -81.6023373],
  image_url: "https://lh3.googleusercontent.com/p/AF1QipOhqTjTe5mDAuL5WxZTTs8ojVdm-3vyat-sJPYD=s1600-w900",
  name: "Autobahn Indoor Speedway & Events - Jacksonville, FL",
  rating: 4.6,
  reviews: [
    "I recently went there and I loved it!! I haven’t had so much fun more then I did in a long time. I d",
    "We went here for Axe throwing after dinner for our wedding anniversary! It was a unique and fun nigh",
    "So much adrenalin!  What a rush!",
  ],
};

const flightFit = {
  address: "7022 A C Skinner Pkwy #200",
  coordinates: [30.2471684, -81.5786952],
  image_url: "https://lh3.googleusercontent.com/p/AF1QipNT5DSyEZB-IuQ1xdwqjpkIyrHo86DZEEZcARQC=s1600-w900",
  name: "Flight Fit N Fun Jacksonville",
  rating: 4.3,
  reviews: [
    "Great for exercise and practicing flips. Ball pit, Ninja course, and just trampolines. Lots of kids ",
    "It was a nice environment for the most part. Although no one practiced manners it was a place I woul",
    "Fun place jump around and have fun. I like ice cream. That would be nice to have ice cream and watch",
  ],
};

const bealls = {
  address: "3560 University Blvd W",
  coordinates: [30.26094239999999, -81.62429039999999],
  image_url: "https://lh3.googleusercontent.com/p/AF1QipMSOX7eZGmhnsii8v8QuCSxR1rk4wD4r-SgqyNd=s1600-w900",
  name: "Bealls Outlet",
  rating: 4.4,
  reviews: [
    "The 2 African American young ladies behind the registers were so very helpful, polite & accomodating",
    "Friendly service, good prices, boring store layout.",
    "Found the things I was looking for at a good price",
  ],
};

const bowdenShopping = {
  address: "5711 Bowden Rd",
  coordinates: [30.26527309999999, -81.6062036],
  image_url: "https://lh3.googleusercontent.com/p/AF1QipPqxGvfxtuC4gMhiG2ffN6I2zr01TJDC-k13SlX=s1600-w900",
  name: "Bowden Corners Shopping Center",
  rating: 4.2,
  reviews: [
    "Max smoke shop be careful going there! Guy ripped me off there after I spent good money with him! Co",
    "Best fried squash ever!!  We got it thru the take out window.  Their restaurant is open for eat in. ",
    "Its empty jo good stores at all.",
  ],
};

const dunkin = {
  address: "5150 University Blvd W",
  coordinates: [30.267486, -81.614795],
  image_url: "https://lh3.googleusercontent.com/p/AF1QipMN1RuQJ2by3iVQDFekRiVcU-vOjS_ta5sv2ulC=s1600-w900",
  name: "Dunkin'",
  rating: 3.8,
  reviews: [
    "The slowest place DD I've ever been to. I ordered a medium coffee.  You would have thought I ordered",
    "Good morning I went in for a hot peppermint mocha latte they were out so I tried the gingerbread and",
    "Great 👍🏻 service! And this creature creations genius move #BR ! My daughter loved U0001f970 it!",
  ],
};

const palmyra = {
  address: "3615 Dupont Ave #100",
  coordinates: [30.2560844, -81.62519069999999],
  image_url: "https://lh3.googleusercontent.com/p/AF1QipP_g3BN9R--rf00Xq0D4vfjCooAy9ZaR5bxRgb2=s1600-w900",
  name: "Palmyra Cafe & Lounge",
  rating: 4.9,
  reviews: [
    "Best family-owned cafe in Jacksonville! The coffee and food is amazing. All the drinks are hand craf",
    "Such a peaceful, cute spot with unique drinks and food to try. Good find :-) also, 10/10 would recom",
    "Wow, my iced latte was amazing! The people who work there are really kind. Great place! Planning to ",
  ],
};

const victory = {
  address: "6601 Executive Park Ct N",
  coordinates: [30.2553288, -81.60202269999999],
  image_url: "https://lh3.googleusercontent.com/p/AF1QipPbOZ49LHUczmT86upp91uvKJL_JhaQrR-mYnVN=s1600-w900",
  name: "Victory Lap BBQ Social",
  rating: 4.5,
  reviews: [
    "Visited at 7:00 PM on 24 January 2021. Only 1 person working the entire restaurant and bar. Had 1 gu",
    "Found this jem by accident looking for a BBQ place to eat for my bday a couple weeks ago. I was a li",
    "Mr Phil was absolutely exceptional thank you so much sir for your kindness",
  ],
};

const applebies = {
  address: "5055 J Turner Butler Blvd",
  coordinates: [30.245916, -81.5983966],
  image_url: "https://lh3.googleusercontent.com/p/AF1QipPiQzL9NTqiW02a58xaQroAcOTP5kRl0L8OIfV1=s1600-w900",
  name: "Applebee's Grill + Bar",
  rating: 3.8,
  reviews: [
    "I haven’t been to an Applebee’s in probably like 6 years. I had kind of given up on them. We didn’t ",
    "The food was OK and the place didn't smell that great. We went to the restaurant for a birthday part",
    "Quick seating for lunch and food came out timely. Friendly service. One weird thing is the switch to",
  ],
};

const samuel = {
  address: "7000 Powers Ave",
  coordinates: [30.249874, -81.615734],
  image_url: "https://lh3.googleusercontent.com/p/AF1QipNR6LEbc1s8ZjRGAQjkkGkVMRM14-mN_xs_49Cv=s1600-w900",
  name: "Samuel W. Wolfson High School",
  rating: 2.8,
  reviews: [
    "It's a typical city highschool, but pretty good as far as low noise levels.",
    "As per my experience I say with ernest that whatever charm this school had has been ruined by the ne",
    "Eh from a students opinion it sucks but there's some interesting people",
  ],
};

const sanJose = {
  address: "3619 Toledo Rd",
  coordinates: [30.2483345, -81.6243868],
  image_url: "https://lh3.googleusercontent.com/p/AF1QipNKPUWfd43_i5l6h7jdRzmn5oodEzHF_S0_tO-d=s1600-w900",
  name: "San Jose Catholic Grade School",
  rating: 3.2,
  reviews: [
    "Worst teachers ever. One of the only good experiences that my son had was with Mrs. Farrell.",
    "I can’t say enough positive things about San Jose Catholic. I love that my girls are well taken care",
    "I have 2 kids at the school with a 3rd enrolling soon.  I cannot say enough nice things about the ex",
  ],
};

const ascension = {
  address: "4201 Belfort Rd",
  coordinates: [30.2537365, -81.5813663],
  image_url: "https://lh3.googleusercontent.com/p/AF1QipNWLHqNvX8lPs8LS9kMPfa_KstMw7U1hrit8---=s1600-w900",
  name: "Ascension St. Vincent's Southside Hospital",
  rating: 3,
  reviews: [
    "I recently had cervical spine surgery at St Vincent's and have to say the staff and nurses were outs",
    "Had to come here unexpectedly to birth my daughter due to complications with my birth center. This w",
    "I came to St Vincent’s due to miscarriage. The staff was beyond compassionate and, understanding. Fr",
  ],
};

const curaHealth = {
  address: "4901 Richard St",
  coordinates: [30.271677, -81.61555],
  image_url: "https://lh3.googleusercontent.com/p/AF1QipNZdGUSVlQPJzBIWC6xsf5jFzOopukOdAzrv6YY=s1600-w900",
  name: "Curahealth Jacksonville",
  rating: 2.7,
  reviews: [
    "I stayed at Curahealth for 16 days. I was quite worried after reading the reviews. I found it to be ",
    "I am a former employee of Curahealth and can say without a doubt this place is A PATIENT AND FAMILIE",
    "Worst, worst, worst, worst, worst, worst, worst, worst, worst, worst, worst hospital in the country.",
  ],
};

const holmes = {
  address: "7035 Philips Hwy #10",
  coordinates: [30.2454001, -81.60067509999999],
  image_url: "https://fileserver.scythargon.ru/holmes.png",
  name: "Mike Holmes Fitness",
  rating: 5,
  reviews: ["Great place to get your workout on. Very comfortable."],
};

const laFitness = {
  address: "3600 University Blvd W",
  coordinates: [30.2613494, -81.6235446],
  image_url: "https://lh3.googleusercontent.com/p/AF1QipPqaWkGr6oL6TaayGpnId5WU7a2JmufNnJhfrCk=s1600-w900",
  name: "LA Fitness",
  rating: 4.1,
  reviews: [
    "It's ok",
    "My one star review is not towards the employees but mainly towards the cleanliness of the facility. ",
    "Me and my friends have had separate interactions with same guy with long hair. Not a coincidence, an",
  ],
};

const joeMart = {
  address: "6270 Powers Ave",
  coordinates: [30.2588585, -81.6191281],
  image_url: "https://lh3.googleusercontent.com/p/AF1QipPRZNWo7r7jqvKF-t_d9N4gnkY0u0X0t02BK0jH=s1600-w900",
  name: "Joe Mart Food Store",
  rating: 3.7,
  reviews: ["Moldy expired packaged food :(", "Good place.", "Love this store"],
};

const alladin = {
  address: "6925 St Augustine Rd",
  coordinates: [30.2515951, -81.6256523],
  image_url: "https://lh3.googleusercontent.com/p/AF1QipO_KNDhSVKljlQ1mAnbPi89hsVQ1KN3GIqoyHrY=s1600-w900",
  name: "Aladdin Food Store",
  rating: 4.4,
  reviews: [
    "They always have what I need. Super helpful.  The lady at the register is always helpful with me and",
    "Nice Mediterranean and Arabic food store\nThe staff are so and friendly and welcoming",
    "Love the the different varieties! Owners are extremely nice and helpful.",
  ],
};

const petParadise = {
  address: "5140 University Blvd W",
  coordinates: [30.26618269999999, -81.6141469],
  image_url: "https://lh3.googleusercontent.com/p/AF1QipOP2SFYzJFiaO0F-IuckalTsPicfke7pLeyzjLv=s1600-w900",
  name: "Pet Paradise Veterinary Hospital",
  rating: 5,
  reviews: [
    "I greatly appreciate the care and professionalism of Dr. McFarland and the entire veterinary team. T",
    "Were so sweet to our elderly dog and took such great care of him while we were gone!!!",
    "Dr. McFarland and staff are very easy going and great to have helping keep your animals well and hea",
  ],
};

const companion = {
  address: "6003 Philips Hwy",
  coordinates: [30.2615375, -81.6142246],
  image_url: "https://lh3.googleusercontent.com/p/AF1QipPK-1in2umK_HMduNdio6k4ZRsvxP6VFGirWWio=s1600-w560",
  name: "Companion Animal Hospital of North Florida",
  rating: 4.9,
  reviews: [
    "Best vets ever! I love Dr Alosilla & my dog really loves him. He goes over & beyond to make sure she",
    "I always recommend companion animal hospital. Loving vets and staff towards my dog Sammy and reasona",
    "Dr. Carlos is the best! Along with all of his staff, my cats are in great hands. I appreciate the ti",
  ],
};

const zobra = {
  address: "2626 E 12th Ave",
  coordinates: [39.735017, -104.955622],
  image_url: "https://lh3.googleusercontent.com/p/AF1QipPGcb-sFnZSCZjDJo4-U1PPJXa_efKC8pFD2uTQ=s1600-w900",
  name: "Chef Zorba's",
  rating: 4.5,
  reviews: [
    "I’ve only been here once, but left with a good feeling overall.  The service was really good and fel",
    "Ordered the gyro with onion rings and the chicken lemon soup. This place is lit. The gyro was absolu",
    "Super good food! Beautiful remodel and great location. Also the coffee was great just what I needed ",
  ],
};

const goddard = {
  address: "1733 Vine St",
  coordinates: [39.7437451, -104.9626674],
  image_url: "https://lh3.googleusercontent.com/p/AF1QipP6Qweuf_XRQQZ0eBbg4wMAhQcUP9-lIZV4LU71=s1600-w900",
  name: "The Goddard School of Denver (City Park West)",
  rating: 4.6,
  reviews: [
    "My family tried to navigate childcare with our newborn son for the first 3 years of his life, with n",
    "We recently moved to Denver and have enjoyed The Goddard School so far. The teachers are all incredi",
    "Our toddler son attends this Goddard School and we have been so pleased. The staff is friendly, atte",
  ],
};

const wymans = {
  address: "2033 E 13th Ave",
  coordinates: [39.73697, -104.962623],
  image_url: "https://lh3.googleusercontent.com/p/AF1QipPujtF4Vt6iZAQsV4Il9644z5BAUtZONG5bijkj=s1600-w900",
  name: "Wyman's",
  rating: 4.3,
  reviews: [
    "Excellent place. I come here often and I love it. The service and food is so consistent and I’ve nev",
    "Great thin crust pizza. The sauce isn't too heavy, the cheese was right. Reminded me of being back h",
    "Great authentic Chicago Deep Dish pie! Laid back atmosphere and very reasonably priced. One of my fa",
  ],
};

const greendor = {
  address: "2404 E Colfax Ave",
  coordinates: [39.7399013, -104.9586514],
  image_url: "https://lh3.googleusercontent.com/p/AF1QipP2tA4ae8byLaGkBKZOGoxEfmPQ1EnOrVWgMKYk=s1600-w900",
  name: "Green Door Fitness",
  rating: 4.9,
  reviews: [
    "Green Door is a fantastic gym! It is great to be able to go into a gym and have a skilled trainer al",
    "This gym is extremely unique in the way they set up your workouts and the energy of the space. There",
    "Green Door is a small welcoming gym.  The instructors help guide you through a workout of your choic",
  ],
};

const copper = {
  address: "1085 York St",
  coordinates: [39.7333019, -104.960189],
  image_url: "https://lh3.googleusercontent.com/p/AF1QipNx32Dp0mKOE5V6rUWZ_Wzu1ieRUHxzXZLITptc=s1600-w900",
  name: "Copper Door Coffee Roasters",
  rating: 4.7,
  reviews: [
    "This phenomenal little coffee shop never disappoints! I love that it is fair trade and women owned. ",
    "Oh my goodness, this place is FANTASTIC! The moment I walked in a didn’t want to leave. There are pl",
    "Went after a lovely day at the Botanical Gardens. This place is clean and very inviting.\n\nCold brew ",
  ],
};

const familyMedicine = {
  address: "1960 N Ogden St #600",
  coordinates: [39.74690349999999, -104.9744788],
  image_url: "https://lh3.googleusercontent.com/p/AF1QipPS6hUGwL0tA5L0ArNshZQ3Cb5CbGcJeOk3eTk6=s1600-w900",
  name: "Denver Family Medicine",
  rating: 3.2,
  reviews: [
    "Denver Family Medicine is the friendliest medical practice I've ever been to. I've seen all the doct",
    "In regards to my visit here I only offer some advice. In seeking a medical provider, do not settle f",
    "I had a great experience visiting this office. Clean and welcoming environment. Professional and fri",
  ],
};

const wholeFoodsMarket = {
  address: "900 E 11th Ave",
  coordinates: [39.7332915, -104.9758502],
  image_url: "https://lh3.googleusercontent.com/p/AF1QipPBvOFYT_lm2Ox7RGCtCBBMf0Qkw4iLhE9rpl9c=s1600-w900",
  name: "Whole Foods Market",
  rating: 4.2,
  reviews: [
    "Wide selection of Gourmet prepared food, pizzas, meats, cheeses. Along with drinks and healthy snack",
    "Ok. I didn't leave a review but... the prepared food is horrible. The chef, whoever it is, allows wa",
    "You should go here if you like great service or friendly people and don't care for being rushed thro",
  ],
};

const midnight = {
  address: "2220 E Colfax Ave",
  coordinates: [39.7397645, -104.9603102],
  image_url: "https://lh3.googleusercontent.com/p/AF1QipP88JHGmmwJB3OQrWmkr58vKq_BocgOfiIDm3wA=s1600-w900",
  name: "Midnight Rambler Boutique",
  rating: 4.6,
  reviews: [
    "They wouldnt take my cash, but had no problem touching my card. If it's an issues with sanitation, c",
    "super cute clothes and beautiful accessories and crystals. Emma was so helpful with the clothing sid",
    "Great stuff. P",
  ],
};

const bffs = {
  address: "4613 E 23rd Ave",
  coordinates: [39.75129209999999, -104.9334749],
  image_url: "https://lh3.googleusercontent.com/p/AF1QipN1sukUrTrFux5dWKlV5zGq4GwKXSXb50txz1iE=s1600-w900",
  name: "Best Friends Forever Pet Care",
  rating: 4.3,
  reviews: [
    "When my favorite kennel service  went out of business (Covid-19), I decided to try using in-home pet",
    "I’ve been using BFF Petcare for our dog sitting and have not been disappointed. The owners and emplo",
    "Dre and Snoop love BFF! Everyone that works there is super friendly and our dogs love them! Thank yo",
  ],
};

const denverZoo = {
  address: "2300 Steele St",
  coordinates: [39.7501637, -104.948953],
  image_url: "https://lh3.googleusercontent.com/p/AF1QipPcOnCpOaKH1Vnbf49GScVcVkEboox81neO5TIp=s1600-w900",
  name: "Denver Zoo",
  rating: 4.6,
  reviews: [
    "An excellent large zoo with a huge variety of animals. I think both adults and children will like th",
    "Very organized with one way traffic during these weird times. Many helpful volunteers that were happ",
    "Wow! We got stuck in Denver in a layover because of the snow storm. We decided to stay and make the ",
  ],
};

export const getCardsData = (chatID, categoryName) => {
  let matches = {};
  // RedPeak
  if (chatID === 1461) {
    matches = {
      Childcare: [goddard],
      Health: [familyMedicine],
      Fitness: [greendor],
      Grocery: [wholeFoodsMarket],
      Pets: [bffs],
      Activities: [denverZoo],
      Shops: [midnight],
      Coffee: [copper],
      Bars: [wymans, zobra],
    };
  }
  // Pointe Sienna Apartment Homes
  else if (chatID === 1458) {
    matches = {
      Childcare: [samuel, sanJose],
      Health: [ascension, curaHealth],
      Fitness: [holmes, laFitness],
      Grocery: [joeMart, alladin],
      Pets: [petParadise, companion],
      Activities: [autobahn, flightFit],
      Shops: [bealls, bowdenShopping],
      Coffee: [dunkin, palmyra],
      Bars: [victory, applebies],
    };
  } else {
    matches = {
      Childcare: [school],
      Health: [hospital],
      Fitness: [fitness],
      Grocery: [grocery],
      Pets: [dogs],
      Activities: [alley, edmunds],
      Shops: [hampden],
      Coffee: [cafe],
      Bars: [moose],
    };
  }

  return matches[categoryName];
};
